export default "__VITE_ASSET__DuBAWnc9__"